import { FileUploadModel } from "../../models/FileUploadModel";
import { ActionTypes } from "../actions/types";
import {
    FILE_UPLOAD_STARTED,
    FILE_UPLOAD_PROGRESS,
    FILE_UPLOAD_COMPLETED,
    FILE_UPLOAD_FAILED,
} from "../actions";

const INITIAL_STATE: FileUploadModel[] = [];

export const filesReducer = (state = INITIAL_STATE, action: ActionTypes): FileUploadModel[] => {
    switch (action.type) {
        case FILE_UPLOAD_STARTED: {
            const { variableName, matrix, fileName, size } = action;
            return [
                ...state.filter((f) => f.variableName !== variableName || f.matrix !== matrix),
                { variableName, matrix, fileName, size, status: "started", progress: 0 },
            ];
        }
        case FILE_UPLOAD_PROGRESS: {
            const { variableName, matrix, progress } = action;
            const file = state.find((f) => f.variableName === variableName && f.matrix === matrix);
            return [
                ...state.filter((f) => f.variableName !== variableName || f.matrix !== matrix),
                { ...file, status: "ongoing", progress },
            ];
        }
        case FILE_UPLOAD_COMPLETED: {
            const { variableName, matrix } = action;
            const file = state.find((f) => f.variableName === variableName && f.matrix === matrix);
            return [
                ...state.filter((f) => f.variableName !== variableName || f.matrix !== matrix),
                { ...file, status: "completed", progress: 1 },
            ];
        }
        case FILE_UPLOAD_FAILED: {
            const { variableName, matrix } = action;
            const file = state.find((f) => f.variableName === variableName && f.matrix === matrix);
            return [
                ...state.filter((f) => f.variableName !== variableName || f.matrix !== matrix),
                { ...file, status: "failed" },
            ];
        }
        default:
            return state;
    }
};
